module.exports = __webpack_public_path__ + "media/Ring 3.fe371a16.mp3";